import { createApp } from 'vue'
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import './plugins/axios';
import '@mdi/font/css/materialdesignicons.css';

const vuetify = createVuetify({
  components,
  directives,
})

// Initialize app
const app = createApp(App);

// Check if there's a token in localStorage and set axios header
const token = localStorage.getItem('jury_token');
if (token) {
  console.log('Token found in localStorage, setting axios header');
  import('axios').then(axios => {
    axios.default.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  });
}

// Restore session before mounting the app
console.log('Attempting to restore session...');
store.dispatch('restoreSession').then((restored) => {
  console.log('Session restoration result:', restored);

  app.use(router)
    .use(store)
    .use(i18n)
    .use(vuetify)
    .mount('#app');
}).catch(error => {
  console.error('Error during session restoration:', error);

  // Mount app anyway even if session restore fails
  app.use(router)
    .use(store)
    .use(i18n)
    .use(vuetify)
    .mount('#app');
});